{
  "SearchAvailabilityInput": {
    "availability": "可用性",
    "clear": "清除",
    "from": "从",
    "to": "至",
    "date": "日期",
    "selectDates": "选择日期"
  },
  "ResourceMetaFilters": {
    "available": "可用"
  },
  "GenericSearch": {
    "Filter": "筛选",
    "Tags": "标签",
    "Belongs to me": "属于我",
    "Published only": "仅已发布",
    "Drafts only": "仅草稿",
    "Last week": "上周",
    "Show archived": "显示已归档",
    "sorts": {
      "Created": "创建",
      "Updated": "更新"
    }
  },
  "TagsFilter": {
    "Tags": "标签",
    "matchAll": "匹配所有",
    "matchAny": "匹配任意",
    "addTag": "添加标签",
    "add": "添加"
  },
  "SearchSorts": {
    "sortBy": "排序",
    "sorts": {
      "Created": "创建",
      "Updated": "更新",
      "Booking Status": "预订状态"
    }
  },
  "StatusSelectorMultiple": {
    "filterStatus": "筛选状态",
    "showAll": "显示全部"
  },
  "ResourceAdvancedSearch": {
    "addFilters": "添加过滤器",
    "clearAll": "清除所有"
  },
  "SearchField": {
    "editGroups": "编辑组",
    "clear": "清除",
    "labels": {
      "Location": "地点",
      "Tags": "标签",
      "Groups": "组",
      "Rates": "费率"
    },
    "measurementsUnitsInfo": "过滤将搜索所有单位",
    "select": "选择",
    "search": "搜索 {{label}}",
    "searchLocation": "搜索地点",
    "currency": {
      "select": "选择",
      "searchPlaceholder": "搜索 {{label}}"
    },
    "singleSelect": {
      "defaultPlaceholder": "搜索选项"
    },
    "tagSelect": {
      "defaultPlaceholder": "搜索标签"
    },
    "multiSelect": {
      "defaultPlaceholder": "搜索选项"
    },
    "resourceSelect": {
      "defaultPlaceholder": "搜索资源"
    },
    "searchTypes": {
      "LONG_TEXT": {
        "eq": "等于"
      },
      "PERCENTAGE": {
        "eq": "等于"
      },
      "SHORT_TEXT": {
        "eq": "等于",
        "s_with": "开头是",
        "e_with": "结尾是",
        "contains": "包含"
      },
      "BOOLEAN": {
        "eq": "等于"
      },
      "NUMBER": {
        "eq": "等于",
        "gte": "大于",
        "lte": "小于"
      },
      "CURRENCY": {
        "eq": "等于",
        "gte": "大于",
        "lte": "小于"
      },
      "MULTI_SELECT": {
        "match": "匹配",
        "any": "任意"
      },
      "TAG_SELECT": {
        "match": "匹配",
        "any": "任意"
      },
      "RESOURCE_SELECT": {
        "match": "匹配"
      },
      "SINGLE_SELECT": {
        "eq": "等于"
      },
      "DATE": {
        "eq": "等于"
      },
      "URL": {
        "eq": "等于"
      },
      "MEASUREMENT": {
        "eq": "等于",
        "gte": "大于",
        "lte": "小于"
      },
      "NETSUITE_VENDOR": {
        "eq": "等于"
      },
      "HEIGHT": {
        "eq": "等于",
        "gte": "大于",
        "lte": "小于"
      },
      "NETSUITE_PO": {
        "eq": "等于"
      }
    },
    "matchingTypes": {
      "matchingType": "匹配类型",
      "match": "匹配所有",
      "any": "匹配任意"
    }
  },
  "TagInput": {
    "add": "添加",
    "add_many": "添加"
  },
  "SelectResourceGroup": {
    "groups": "分组",
    "all": "全部",
    "groupSelected": "{{count}} 组已选",
    "groupSelected_all": "所有组"
  },
  "NoteItem": {
    "archive": "归档"
  },
  "EventDateRange": {
    "labelStart": "开始",
    "labelEnd": "结束",
    "addAnotherDate": "添加另一个日期"
  },
  "EventHoursInput": {
    "hoursLabel": "小时"
  },
  "EventHelper": {
    "allDay": "全天",
    "recurringLabel": "{{hours}}小时{{minutes}} / 天"
  },
  "Loading": {
    "justAMoment": "请稍等"
  },
  "FileUploader": {
    "uploading": "上传中",
    "complete": "完成",
    "dragFilesHereOr": "拖拽文件到此处或",
    "clickToUpload": "点击上传",
    "maxFileUploadSize": "超过了最大上传文件大小。"
  },
  "FileUploadingItem": {
    "untitledFile": "未命名文件",
    "failed": "失败",
    "complete": "完成"
  },
  "EventHoursInputOptions": {
    "allDay": "全天",
    "hoursPerDay": "每天小时数",
    "hours": "小时",
    "minutes": "分钟",
    "specificTimes": "具体时间",
    "from": "从",
    "to": "至"
  }
}
